import tree from '../state';
import * as authService from '../services/authService';

export const enterAuthAction = ({ params }, replace, callback) => {
    tree.set('loading', true);
    authService.getToken().then(res => {
    	if(res.status === 200){
            tree.set('token', res.header.authorization);
        }
        tree.set('loading', false);
        callback();
    });
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js